
export const ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_CLASS_COURSE_LIST = 'ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_CLASS_COURSE_LIST';//教材计划列表
export const ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_CLASS_LIST = 'ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_CLASS_LIST';//结算班级列表
export const BOOK_STATEMENT_BOOK_CATALOG_CREATE = 'BOOK_STATEMENT_BOOK_CATALOG_CREATE';
export const EDITING_THE_TEACHING_MATERIAL = 'EDITING_THE_TEACHING_MATERIAL';
export const BOOK_STATEMENT_BOOK_DISCOUNT = 'BOOK_STATEMENT_BOOK_DISCOUNT';
export const ACTION_SCHOOL_ADMIN_TOOL_DATA_IMPORT_LIST = 'ACTION_SCHOOL_ADMIN_TOOL_DATA_IMPORT_LIST';//数据导入列表
export const ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_BOOK_CATALOG = 'ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_BOOK_CATALOG';
export const ACTION_GET_CLASS_STUDENT_MASSAGE_LIST_PORT_MODEL = 'ACTION_GET_CLASS_STUDENT_MASSAGE_LIST_PORT_MODEL';//班级学生信息列表
export const ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_COURSE_TYPE_LIST = 'ACTION_SCHOOL_ADMIN_TOOL_BOOK_STATEMENT_COURSE_TYPE_LIST';
export const EDITING_CHANGE_CLASS_MANAGEMENT_NAME = 'EDITING_CHANGE_CLASS_MANAGEMENT_NAME';
export const ACTION_ADMIN_TOOL_DATA_IMPORT_PROCESS_DETAIL = 'ACTION_ADMIN_TOOL_DATA_IMPORT_PROCESS_DETAIL';
//学院列表
export const ACTION_SETTLE_ACCOUNTS_COLLEGE_LIST_PORT = 'ACTION_SETTLE_ACCOUNTS_COLLEGE_LIST_PORT';
//改变班级
export const ACTION_CHANGE_CLASS_LIST_OF_BATCH = 'ACTION_CHANGE_CLASS_LIST_OF_BATCH';



// WEBPACK FOOTER //
// ./src/store/Admin/modules/textBookSchedule/types.js